// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n[dir] .btn-hover-trash[data-v-78dd6aa1]:hover {\r\n  border-radius: 4px;\n}\n[dir=ltr] .btn-hover-trash[data-v-78dd6aa1]:hover {\r\n  background: linear-gradient(to right, #ffe5e5, #ffcccc);\n}\n[dir=rtl] .btn-hover-trash[data-v-78dd6aa1]:hover {\r\n  background: linear-gradient(to left, #ffe5e5, #ffcccc);\n}\r\n", ""]);
// Exports
module.exports = exports;
